//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LoadingIndicator from '../../assets/loading-indicator/loading-indicator.vue'
import PromoOverlayMobile from './-component/-promo-overlay-mobile.vue'
export default {
  auth: false,
  components: {
    Slick: () => import('vue-slick'),
    PromoOverlayMobile,
    LoadingIndicator
  },
  layout: 'front-page',
  data: () => ({
    isCategoryLoading: false,
    isPromoLoading: false,
    isOvelayShown: false,
    showCarouselEvent: false,
    isOnPhone: false,
    isCategoryDropdownExpanded: false,
    slickComp: '',
    slickKlienOptions: {
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      centerMode: true,
      autoplay: true,
      autoplaySpeed: 7000,
      dots: false,
      infinite: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            arrows: false
          }
        },
        {
          breakpoint: 577,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            arrows: false
          }
        }
      ]
    },
    promoList: [],
    categoryList: [],
    selectedCategoryId: -1,
    selectedPromoImage: {}
  }),
  async fetch () {
    await this.fetchCategoryList()
  },
  watch: {
    categoryList (list, _) {
      if (list.length > 0) {
        this.selectedCategoryId = list[0].id
      }
    },
    selectedCategoryId (id, _) {
      if (id !== -1) {
        this.fetchPromo()
      }
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.onChangeWindowSize)
  },
  mounted () {
    window.addEventListener('resize', this.onChangeWindowSize)
    this.$nextTick(function () {
      this.onChangeWindowSize()
    })
  },
  methods: {
    navigateToASlide (i) {
      this.$refs.slick.goTo(i)
    },
    onChangeWindowSize (_) {
      if (window.innerWidth < 576) {
        this.isOnPhone = true
        return
      }
      this.isOnPhone = false
    },
    toggleCategoryLoading () {
      this.isCategoryLoading = !this.isCategoryLoading
    },
    async fetchCategoryList () {
      this.toggleCategoryLoading()
      const response = await this.$axios.$get('/api/promo/list')
      this.categoryList = []
      this.categoryList = response.data
      this.toggleCategoryLoading()
    },
    async fetchPromo () {
      this.isPromoLoading = true

      await this.$axios
        .$get('/api/promo/' + this.selectedCategoryId)
        .then((res) => {
          this.isPromoLoading = true
          this.promoList = res.data
          this.$nextTick(function () {
            this.slickComp = 'Slick'
          })
        })
        .catch(() => {
          this.$toast.error('Gagal memuat data, mohon coba kembali')
        })
        .finally(() => {
          this.isPromoLoading = false
        })
    },
    selectCategory (id) {
      this.selectedCategoryId = id
    },
    onSelectPromo (promo) {
      this.selectedPromoImage = {
        img: promo.img_path,
        url: promo.url
      }
      this.showOverlay()
    },
    onCloseOverlay () {
      this.selectedPromoImage = {}
      this.isOvelayShown = false
    },
    showOverlay () {
      this.isOvelayShown = true
    }
  }
}
